var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:`${_vm.color}--text`,attrs:{"x-small":"","outlined":""},on:{"click":function($event){return _vm.onClick(_vm.modelValue)}}},[_vm._v(" Preview ")])
}
var staticRenderFns = []

export { render, staticRenderFns }